import { type CSSProperties } from "react";
import { isUrl } from "../utils/isUrl";

interface QuoteSourceProps {
  source?: string | null;
  style?: CSSProperties;
  linkStyle?: CSSProperties;
}

export function QuoteSource({ source, style, linkStyle }: QuoteSourceProps) {
  if (!source) {
    return null;
  }

  if (isUrl(source)) {
    return (
      <a href={source} target="_blank" rel="noreferrer" style={linkStyle ?? style}>
        {source}
      </a>
    );
  }

  return <span style={style}>{source}</span>;
}
